import { Combobox } from '@/components/ui/combobox'

export type CountryComboboxOption = {
  code: string
  name: string
}

type Props = {
  countries: CountryComboboxOption[]
  value: string
  onValueChange: (value: string) => void
  id?: string
  ariaInvalid?: boolean
  ariaDescribedBy?: string
  disabled?: boolean
  className?: string
  placeholder?: string
}

export function CountryCombobox({
  countries,
  value,
  onValueChange,
  id,
  ariaInvalid,
  ariaDescribedBy,
  disabled,
  className,
  placeholder = 'Choose a country',
}: Props) {
  return (
    <Combobox
      id={id}
      options={countries.map((country) => ({ value: country.code, label: country.name, keywords: country.code }))}
      value={value}
      onValueChange={onValueChange}
      ariaInvalid={ariaInvalid}
      ariaDescribedBy={ariaDescribedBy}
      disabled={disabled}
      className={className}
      placeholder={placeholder}
      searchPlaceholder="Search countries…"
      emptyMessage="No countries found."
    />
  )
}
